import { scrollbarEmits as q, scrollbarProps as F } from "./index671.js";
import { defineComponent as G, ref as d, computed as w, watch as C, nextTick as E, provide as J, reactive as Q, onActivated as X, onMounted as Y, onUpdated as Z, openBlock as y, createElementBlock as _, normalizeClass as g, unref as ee, createElementVNode as te, normalizeStyle as L, createBlock as N, resolveDynamicComponent as le, withCtx as re, renderSlot as oe, createCommentVNode as ae } from "vue";
import { useResizeObserver as O, useEventListener as ie } from "./index562.js";
import se from "./index751.js";
import { scrollbarContextKey as ne } from "./index673.js";
import { useNamespace as ce } from "./index559.js";
import { addUnit as H } from "./index641.js";
import { isObject as fe } from "./index575.js";
import { isNumber as p } from "./index565.js";
import { debugWarn as A } from "./index588.js";
const ue = ["tabindex"], z = "ElScrollbar";
var ze = /* @__PURE__ */ G({
  name: z,
  __name: "scrollbar",
  props: F,
  emits: q,
  setup(o, { expose: D, emit: W }) {
    const r = o, R = W, u = ce("scrollbar");
    let b, h, S, n = 0, i = 0, a = "";
    const f = {
      bottom: !1,
      top: !1,
      right: !1,
      left: !1
    }, T = d(), t = d(), x = d(), m = d(), B = w(() => {
      const e = {}, l = H(r.height), s = H(r.maxHeight);
      return l && (e.height = l), s && (e.maxHeight = s), [r.wrapStyle, e];
    }), I = w(() => [
      r.wrapClass,
      u.e("wrap"),
      { [u.em("wrap", "hidden-default")]: !r.native }
    ]), K = w(() => [u.e("view"), r.viewClass]), M = (e) => {
      var l;
      return (l = f[e]) != null ? l : !1;
    }, P = {
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }, U = (e) => {
      const l = P[a];
      if (!l) return;
      const s = e[a], v = e[l];
      s && !f[a] && (f[a] = !0), !v && f[l] && (f[l] = !1);
    }, k = () => {
      var e;
      if (t.value) {
        (e = m.value) == null || e.handleScroll(t.value);
        const l = n, s = i;
        n = t.value.scrollTop, i = t.value.scrollLeft;
        const v = {
          bottom: n + t.value.clientHeight >= t.value.scrollHeight - r.distance,
          top: n <= r.distance && l !== 0,
          right: i + t.value.clientWidth >= t.value.scrollWidth - r.distance && s !== i,
          left: i <= r.distance && s !== 0
        };
        if (R("scroll", {
          scrollTop: n,
          scrollLeft: i
        }), l !== n && (a = n > l ? "bottom" : "top"), s !== i && (a = i > s ? "right" : "left"), r.distance > 0) {
          if (M(a))
            return;
          U(v);
        }
        v[a] && R("end-reached", a);
      }
    };
    function V(e, l) {
      fe(e) ? t.value.scrollTo(e) : p(e) && p(l) && t.value.scrollTo(e, l);
    }
    const $ = (e) => {
      if (!p(e)) {
        A(z, "value must be a number");
        return;
      }
      t.value.scrollTop = e;
    }, j = (e) => {
      if (!p(e)) {
        A(z, "value must be a number");
        return;
      }
      t.value.scrollLeft = e;
    }, c = () => {
      var e;
      (e = m.value) == null || e.update(), f[a] = !1;
    };
    return C(
      () => r.noresize,
      (e) => {
        e ? (b?.(), h?.(), S?.()) : ({ stop: b } = O(x, c), { stop: h } = O(t, c), S = ie("resize", c));
      },
      { immediate: !0 }
    ), C(
      () => [r.maxHeight, r.height],
      () => {
        r.native || E(() => {
          var e;
          c(), t.value && ((e = m.value) == null || e.handleScroll(t.value));
        });
      }
    ), J(
      ne,
      Q({
        scrollbarElement: T,
        wrapElement: t
      })
    ), X(() => {
      t.value && (t.value.scrollTop = n, t.value.scrollLeft = i);
    }), Y(() => {
      r.native || E(() => {
        c();
      });
    }), Z(() => c()), D({
      /** @description scrollbar wrap ref */
      wrapRef: t,
      /** @description update scrollbar state manually */
      update: c,
      /** @description scrolls to a particular set of coordinates */
      scrollTo: V,
      /** @description set distance to scroll top */
      setScrollTop: $,
      /** @description set distance to scroll left */
      setScrollLeft: j,
      /** @description handle scroll event */
      handleScroll: k
    }), (e, l) => (y(), _(
      "div",
      {
        ref_key: "scrollbarRef",
        ref: T,
        class: g(ee(u).b())
      },
      [
        te("div", {
          ref_key: "wrapRef",
          ref: t,
          class: g(I.value),
          style: L(B.value),
          tabindex: o.tabindex,
          onScroll: k
        }, [
          (y(), N(le(o.tag), {
            id: o.id,
            ref_key: "resizeRef",
            ref: x,
            class: g(K.value),
            style: L(o.viewStyle),
            role: o.role,
            "aria-label": o.ariaLabel,
            "aria-orientation": o.ariaOrientation
          }, {
            default: re(() => [
              oe(e.$slots, "default")
            ]),
            _: 3
            /* FORWARDED */
          }, 8, ["id", "class", "style", "role", "aria-label", "aria-orientation"]))
        ], 46, ue),
        o.native ? ae("v-if", !0) : (y(), N(se, {
          key: 0,
          ref_key: "barRef",
          ref: m,
          always: o.always,
          "min-size": o.minSize
        }, null, 8, ["always", "min-size"]))
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  ze as default
};
